<template>
  <div style="height: 100%">
    <div style="height: 100%" ref="plot"></div>
  </div>
</template>
<script>
import Plotly from 'plotly.js-dist'
import { api } from '@/main.js'

function yesterday () {
  var d = new Date()
  d.setDate(d.getDate() - 1)
  return d
}

function bToFloat32 (b) {
  let fAry = new Float32Array(b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength))
  return fAry
}

function tsToFloat32 (b) {
  let elems = 1
  b.s.forEach(d => { elems *= d })
  // infer the type used
  let IAry
  let siz
  if (b.d.byteLength / elems === 2) {
    IAry = new Uint16Array(b.d.buffer.slice(b.d.byteOffset, b.d.byteOffset + b.d.byteLength))
    siz = 65536 - 1
  } else if (b.d.byteLength / elems === 1) {
    IAry = b.d
    siz = 256 - 1
  } else {
    console.error('elements not matching!')
  }
  let sca = (b.ma - b.mi) / siz
  let a = new Float32Array(b.d.byteLength)
  let res = a.map((_, idx) => {
    if (IAry[idx] === 0) {
      return NaN
    } else {
      return (IAry[idx] - 1) * sca + b.mi
    }
  })

  console.log('data out', res)
  return res
}

const tab10 = [
  'rgba(31, 119, 180, ',
  'rgba(255, 127, 14, ',
  'rgba(44, 160, 44, ',
  'rgba(214,  39, 40, ',
  'rgba(148, 103, 189, ',
  'rgba(140, 86, 75, ',
  'rgba(227, 119, 194, ',
  'rgba(127, 127, 127, ',
  'rgba(188, 189,  34, ',
  'rgba(23, 190, 207, '
]

export default {
  mounted () {
    // eslint-disable-next-line no-unused-vars
    var layout = {
      title: { text: this.title },
      xaxis: {
        visible: true,
        range: [yesterday(), new Date()],
        type: 'date'
      },
      margin: { // update the left, bottom, right, top margin
        l: 40,
        b: 40,
        r: 0,
        t: 40
      },
      yaxis: {
        visible: true,
        title: { text: this.yLabel },
        fixedrange: false,
        autorange: true
      },
      dragmode: 'pan',
      legend: {
        x: 1,
        xanchor: 'right',
        y: 1,
        bgcolor: 'rgba(255, 255, 255, 0.5)'
      }
    }
    this.plot = Plotly.newPlot(
      this.$refs['plot'],
      [],
      layout,
      { doubleClick: false, scrollZoom: true, responsive: true, displaylogo: false, modeBarButtonsToRemove: ['toImage'] }
    )

    this.$refs['plot'].on('plotly_relayout', eventdata => {
      console.log('callback send event')

      this.updateTime()
      this.redraw()
      console.log(this.$refs['plot'].layout.xaxis.range)
      console.log('send event')
      if (!this.autoUpdate) {
        this.$emit('update:timeRange', [this.$refs['plot'].layout.xaxis.range[0], this.$refs['plot'].layout.xaxis.range[1]])
      }
      this.autoUpdate = false
    })
    this.$refs['plot'].on('plotly_hover', eventdata => {
      this.$emit('update:timeCursor', eventdata.xvals[0] * 1000)
    })

    this.$refs['plot'].on('plotly_legendclick', eventdata => {
      if (this.$refs['plot'].data[eventdata.curveNumber].visible === 'legendonly') {
        Plotly.restyle(this.$refs['plot'], { visible: true }, [eventdata.curveNumber - 2, eventdata.curveNumber - 1, eventdata.curveNumber])
      } else {
        Plotly.restyle(this.$refs['plot'], { visible: false }, [eventdata.curveNumber - 2, eventdata.curveNumber - 1])
        Plotly.restyle(this.$refs['plot'], { visible: 'legendonly' }, eventdata.curveNumber)
      }
      return false
    })

    this.updateTime()
    this.updateTraces()
    this.redraw()
  },
  props: ['traces', 'timeRange', 'traceNames', 'yLabel', 'title', 'cursor'],
  data: function () {
    return {
      tiles: [],
      zoom: 0,
      tilesRendered: [],
      plot: null,
      redrawInProgress: 0,
      autoUpdate: false
    }
  },
  methods: {
    updateTime: function () {
      // Set the required tiles and zoom level for the current time shown in the plot.
      var xRange = this.$refs['plot'].layout.xaxis.range
      var start = new Date(xRange[0]).getTime() * 1000
      var end = new Date(xRange[1]).getTime() * 1000
      var diff = end - start
      for (var zoom = 0; zoom < 12; zoom++) {
        if (diff > 2 ** (64 - 4 * zoom)) {
          break
        }
      }
      zoom = zoom - 1
      var t1 = Math.floor(start / 2 ** (64 - 4 * zoom))
      var t2 = t1 + 1
      this.tiles = [t1, t2]
      this.zoom = zoom
    },
    redraw: function () {
      // Not the best solution yet .. need to have an intermediate step where we check whats actually already rendered ...
      // on shift we can remove the first tile and redraw the next afterwards without a hurry .. =)
      // We could even already get lower and higher zoom levels ...
      if (this.redrawInProgress > 0) {
        return
      }
      this.traces.forEach((el, index) => {
        // el is the sensor_trace which we'd like to get.
        // example: '4c11ae6108ac/adxl357_x' <- DEVICE/SENSOR_TRACE
        const dummy = [0, 1]
        const zoom = this.zoom // this is the current zoom
        const tiles = this.tiles // this is an array with the current required tiles (2)
        let alreadyUpdated1st = false
        // ToDo: use PromiseAll here
        dummy.forEach(t12 => {
          const tileIdent = el + '/' + zoom + '/' + tiles[t12]
          if (tileIdent !== this.tilesRendered[index][t12]) {
            // Tile is not there yet, need to fetch it first:
            // else we don't need to do something!
            this.redrawInProgress += 1
            api.get('/data/' + tileIdent, { responseType: 'arraybuffer' })
              .then(response => {
                // once we have the tile we need to check if it's still required and enter it at the correct position!
                // and update this.tileRendered
                if (zoom === this.zoom & this.tiles[t12] === tiles[t12]) {
                  // yes, tile is still required!
                  let aMin, aMax, aAvg
                  let tsDate = []
                  console.log(response)
                  if (response.data.t === 'd') {
                    response.data.timestamp.forEach(ts => tsDate.push(new Date(ts / 1000)))

                    aMin = bToFloat32(response.data.axis_min)
                    aMax = bToFloat32(response.data.axis_max)
                    aAvg = bToFloat32(response.data.axis_avg)
                  } else if (response.data.t === 'l') {
                    // js does not support to bit shift beyond 32 bit!! Thus the Math.pow hack.
                    let tsStart = tiles[t12] * Math.pow(2, 64 - 4 * zoom)
                    let tsInc = Math.pow(2, (64 - 12) - 4 * zoom)
                    console.log(tiles[t12], zoom, tsStart, tsInc)
                    let tsStamps = Array.from(Array(4096), (_, i) => tsStart + i * tsInc)
                    let c = 0
                    response.data.ts_removed.forEach(index => {
                      tsDate.splice(index - c, 1)
                      c += 1
                    })
                    aMin = tsToFloat32(response.data.axis_max)
                    aMax = tsToFloat32(response.data.axis_min)
                    aAvg = tsToFloat32(response.data.axis_avg)
                    tsStamps.forEach(ts => tsDate.push(new Date(ts / 1000)))
                  } else {
                    console.error('Received unknown encoding option for TimeSeriesTile')
                  }

                  var data = {
                    x: [tsDate, tsDate, tsDate],
                    y: [aMin, aMax, aAvg]
                  }
                  console.log(data)
                  if (!alreadyUpdated1st) {
                    if (this.traceNames !== undefined && this.traceNames[index] !== undefined) {
                      data['name'] = ['', '', this.traceNames[index]]
                    }

                    Plotly.restyle(
                      this.$refs['plot'],
                      data,
                      [index * 3, index * 3 + 1, index * 3 + 2]
                    )
                    alreadyUpdated1st = true
                  } else {
                    if (t12 === 0) {
                      console.log(this.$refs['plot'], data, [index * 3, index * 3 + 1, index * 3 + 2])
                      Plotly.prependTraces(
                        this.$refs['plot'],
                        data,
                        [index * 3, index * 3 + 1, index * 3 + 2]
                      )
                    } else {
                      Plotly.extendTraces(
                        this.$refs['plot'],
                        data,
                        [index * 3, index * 3 + 1, index * 3 + 2]
                      )
                    }
                  }
                  this.tilesRendered[index][t12] = tileIdent
                }
                this.redrawInProgress -= 1
              })
              .catch(error => {
                console.log(error)
                this.redrawInProgress -= 1
              })
          }
        })
      })
    },

    updateTraces: function () {
      if (this.$refs['plot'].data.length > this.traces.length * 3) {
        // too many traces remove some ...
        for (var i = this.$refs['plot'].data.length; i > this.traces.length; i--) {
          Plotly.deleteTraces(this.$refs['plot'], [-3, -2, -1])
          this.tilesRendered.pop()
        }
      } else if (this.$refs['plot'].data.length < this.traces.length * 3) {
        // not enough traces need to add some ...
        for (var j = this.$refs['plot'].data.length; j < this.traces.length; j++) {
          this.tilesRendered.push(['', ''])
          Plotly.addTraces(this.$refs['plot'],
            [
              {
                x: [],
                y: [],
                line: { color: tab10[j] + '0.0)', width: 1 },
                type: 'scatter',
                hoverinfo: 'none',
                showlegend: false,
                connectgaps: false
              }, {
                x: [],
                y: [],
                line: { color: tab10[j] + '0.0)', width: 1 },
                fill: 'tonexty',
                fillcolor: tab10[j] + '0.4)',
                type: 'scatter',
                hoverinfo: 'none',
                showlegend: false,
                connectgaps: false
              }, {
                x: [],
                y: [],
                line: { color: tab10[j] + '1)', width: 1 },
                type: 'scattergl',
                mode: 'lines+markers',
                marker: {
                  size: 2
                },
                connectgaps: false
              }
            ]
          )
        }
      }
    }
  },

  watch: {
    traces: function (val) {
      // 1. setup dummy Traces without data!
      this.updateTraces()
      // update the data in the traces
      this.redraw()
    },
    timeRange: function (val) {
      console.log('timeStart changed')
      this.autoUpdate = true
      var update = {
        'xaxis.range': val
      }
      Plotly.relayout(this.$refs['plot'], update)
    }
  }
}
</script>
